import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import './index.css';
import 'react-pro-sidebar/dist/css/styles.css';
import { ProSidebar, Menu, MenuItem, SubMenu, SidebarContent } from 'react-pro-sidebar';
import { Link } from "react-router-dom";
import { updateSidebarToggle } from '~shared/components/sidebar/services';
import Select from "react-select";
// import bookit from '~shared/stubs/bookit.json';
// import etailPlus from '~shared/stubs/etailPlus.json';
// import ecomm from '~shared/stubs/ecomm.json';
import bookit from '~shared/sidebarList/bookit';
import etailPlus from '~shared/sidebarList/etailPlus';
import ecomm from '~shared/sidebarList/ecomm';
import { setCookie, getCookie, eraseCookie } from "../../utils/cookie";
import { findURLParam, getAppendedSchemaName } from "../../utils/urls";
import useMessagingSidebar from '../../hooks/useMessagingSidebar';
import { BiConversation } from '~shared/icons/bi';
import {_getmanualSlotCheckbox} from '../../../shared/httpService/apis';


const AVAILABLE_DASHBOARDS = [{ name: 'eTailPlus', id: 'etailPlus' }, { name: 'Ecomm Only', id: 'ecomm' }, { name: 'Bookit Only', id: 'bookit' }];

const Sidebar = ({ toggleSidebar, collapsed, toggled, authentication_state}) => {


  const authentication_ref = useRef(authentication_state);
  authentication_ref.current = authentication_state;
  const onToggle = (value) => {
    toggleSidebar(value);
  };
  // const [showNewSlot, setShowNewSlot] = useState(
  //  false
  // );

  // useEffect(() => {
  //   // Set showNewSlot based on the initial value of isChecked
  //  getCheckboxValueFromBackend();
  // }, [showNewSlot]);


  // const getCheckboxValueFromBackend = async () => {
  //   try {
  //     const response= await _getmanualSlotCheckbox().then((res) => {
  //       const isCheckedFromBackend = res.data.active; // Assuming backend returns isChecked
       
  //       localStorage.setItem('isChecked', isCheckedFromBackend); // Update the state based on backend response
  //       setShowNewSlot(isCheckedFromBackend); // Set showNewSlot based on isChecked
  //     });
  //   } catch (error) {
  //     console.error('Error fetching checkbox value from backend:', error);
  //   }
  // };

  


  // Helper function to get initial dashboard from cookie
  const getInitialDashboard = () => {
    const cookieValue = getCookie("sidebar_type");
    if (cookieValue) {
      // Find the dashboard object that matches the cookie value
      const dashboard = AVAILABLE_DASHBOARDS.find(d => d.id === cookieValue);
      if (dashboard) {
        return dashboard;
      }
    }
    // Default to BookIt only if no valid cookie
    return AVAILABLE_DASHBOARDS[2];
  };

  const [selectedDashboard, setSelectedDashboard] = useState(() => {
    // Use lazy initialization to ensure cookie is read at mount time
    return getInitialDashboard();
  });
  const location = useLocation();
  const [openSubMenus, setOpenSubMenus] = useState({});

  const showSidebarMessageItem = useMessagingSidebar()

  // Handle URL parameter for sidebar_type (e.g., from external links)
  useEffect(() => {
    const location = window.location.href;
    const sidebar_type = findURLParam("sidebar_type", location);
    if (sidebar_type) {
      // Normalize 'etailplus' to 'etailPlus' for consistency
      const normalizedType = sidebar_type.toLowerCase() === 'etailplus' ? 'etailPlus' : sidebar_type;
      const dashboard = AVAILABLE_DASHBOARDS.find(d => d.id === normalizedType);
      if (dashboard && selectedDashboard?.id !== dashboard.id) {
        setSelectedDashboard(dashboard);
        setCookie("sidebar_type", dashboard.id);
      }
    }
  }, []);

  // Sync sidebar state with cookie on route changes to preserve selection
  // This ensures that if the component remounts or route changes, we preserve the user's choice
  useEffect(() => {
    const cookieValue = getCookie("sidebar_type");
    if (cookieValue) {
      const dashboard = AVAILABLE_DASHBOARDS.find(d => d.id === cookieValue);
      if (dashboard) {
        // Always sync with cookie to ensure consistency, but only update if different
        // This prevents the sidebar from resetting to BookIt when navigating
        setSelectedDashboard(prevDashboard => {
          if (prevDashboard?.id !== dashboard.id) {
            return dashboard;
          }
          return prevDashboard;
        });
      }
    }
  }, [location.pathname]);

  // Save dashboard selection to cookie whenever it changes
  useEffect(() => {
    if (selectedDashboard?.id) {
      setCookie("sidebar_type", selectedDashboard.id);
    }
  }, [selectedDashboard]);


  const findJsonData = () => {
    switch (selectedDashboard?.id) {
      case 'etailPlus':
        return etailPlus;
      case 'ecomm':
        return ecomm;
      case 'bookit':
        return bookit;
      default:
        return bookit;
    }
  };


  // Helper function to check if a route is active
  const isRouteActive = (routeUrl) => {
    if (!routeUrl) return false;
    const currentPath = location.pathname;
    const stringToAppend = getAppendedSchemaName();
    
    // Remove query params and hash from current path for comparison
    const cleanCurrentPath = currentPath.split('?')[0].split('#')[0];
    
    // Check if the route URL matches the current path
    if (routeUrl.startsWith('/')) {
      // Internal route
      const fullRoute = `${routeUrl}${stringToAppend}`;
      const cleanRoute = fullRoute.split('?')[0].split('#')[0];
      return cleanCurrentPath === cleanRoute || cleanCurrentPath.startsWith(cleanRoute + '/');
    }
    return false;
  };

  // Helper function to check if any child route is active (to keep parent menu open)
  const hasActiveChildRoute = (routes, stringToAppend) => {
    if (!routes || !Array.isArray(routes)) return false;
    return routes.some(route => {
      const routeUrl = route?.isBookitSpecific ? `${route?.url}${stringToAppend}` : route?.url;
      return isRouteActive(routeUrl);
    });
  };

  // Update open submenus when route changes - keep menus open if they have active child routes
  useEffect(() => {
    const data = findJsonData();
    const stringToAppend = getAppendedSchemaName();
    
    setOpenSubMenus(prev => {
      const newOpenSubMenus = { ...prev };
      
      data.forEach((item, index) => {
        if (item?.hasInnerRoutes) {
          const hasActive = hasActiveChildRoute(item?.routes, stringToAppend);
          // If a child route is active, always keep the menu open
          // Otherwise, preserve the user's manual open/close state
          if (hasActive) {
            newOpenSubMenus[index] = true;
          } else if (newOpenSubMenus[index] === undefined) {
            // Only set to false if it was never manually opened
            // Don't override user's manual state
            newOpenSubMenus[index] = false;
          }
        }
      });
      
      return newOpenSubMenus;
    });
  }, [location.pathname, selectedDashboard]);

  const renderSideBarMenu = () => {
    let data = findJsonData();

    if (showSidebarMessageItem) {
      // https://stackoverflow.com/a/586189/11667949
      data = [
        ...data.slice(0, 2),
        {
          title: "Messages",
          icon: <BiConversation />,
          url: '/retailer/messages',
          isBookitSpecific: true,
          retailerSpecific: false,
          hasInnerRoutes: false,
        },
        ...data.slice(2)

      ]
    }


    if (data) {
      const stringToAppend = getAppendedSchemaName()
      return data.map((item, index) => {
        // Check if this item or any of its child routes are active
        const isItemActive = item?.url ? isRouteActive(item?.isBookitSpecific ? `${item?.url}${stringToAppend}` : item?.url) : false;
        const shouldKeepSubMenuOpen = item?.hasInnerRoutes && hasActiveChildRoute(item?.routes);
        
        // Determine if submenu should be open
        // Priority: 1) Active child route (always open), 2) User's manual state, 3) Default closed
        const hasActiveChild = shouldKeepSubMenuOpen;
        const isSubMenuOpen = hasActiveChild || (openSubMenus[index] === true);
        
        // Use a key that includes the open state to force remount when it changes
        // This ensures defaultOpen is properly applied when route changes
        const subMenuKey = `${index}-${isSubMenuOpen ? 'open' : 'closed'}-${location.pathname}`;
        
        return (
          <Menu key={index}>
            {
              item?.hasInnerRoutes ?
                <SubMenu 
                  key={subMenuKey}
                  title={item?.title} 
                  icon={item.icon}
                  defaultOpen={isSubMenuOpen}
                >
                  {item?.routes?.map((route, idx) => {
                    const routeUrl = route?.isBookitSpecific ? `${route?.url}${stringToAppend}` : route?.url;
                    const isActive = isRouteActive(routeUrl);
                    
                    return (
                      <MenuItem key={idx} active={isActive}>
                        {route?.isBookitSpecific ?
                          <Link to={`${route?.url}${stringToAppend}`}>{route?.title}</Link> :
                          route?.retailerSpecific ?
                            <a href={`https://${authentication_ref?.current?.retailer_info?.response?.domain_url}${route?.url}`}>{route?.title}</a> :
                            <a href={`${route?.url}`}>{route?.title}</a>
                        }
                      </MenuItem>
                    );
                  })}
                </SubMenu> :

                <MenuItem icon={item.icon} active={isItemActive}>
                {item?.isBookitSpecific ?
                  <Link to={`${item?.url}${stringToAppend}`}>{item?.title}</Link> :
                  item?.retailerSpecific ?
                    <a href={`https://${authentication_ref?.current?.retailer_info?.response?.domain_url}${item?.url}`}>{item?.title}</a> :
                    <a href={`${item?.url}`}>{item?.title}</a>
                }
              </MenuItem>
              
            }
          </Menu>
        );
      });
    }
    return null;
  };

  return (
    <React.Fragment>
      <div className="">
        <ProSidebar
          collapsed={collapsed}
          toggled={toggled}
          className="left-sidebar"
          breakPoint="lg"
          onToggle={onToggle}
          width="200px"
          collapsedWidth="80px"
        >
          <Select
            getOptionLabel={item => item?.name}
            getOptionValue={item => item?.id}
            options={AVAILABLE_DASHBOARDS}
            value={selectedDashboard}
            onChange={(v) => {
              setSelectedDashboard(v);
              // Save to cookie immediately when user changes selection
              if (v?.id) {
                setCookie("sidebar_type", v.id);
              }
            }}
          />

          <SidebarContent>
            {/* <Menu iconShape="square">
              <SubMenu title="Booking">
                <MenuItem><Link to="/retailer/booking/schedule">Schedule</Link></MenuItem>
                <MenuItem active={true}><Link to="/retailer/booking/configuration">Configuration</Link></MenuItem>
              </SubMenu>
            </Menu>
            <Menu iconShape="circle">
              <MenuItem>
                <Link to="/retailer/customers/1/pet-list">Customers</Link>
              </MenuItem>
            </Menu> */}
            {renderSideBarMenu()}
          </SidebarContent>
        </ProSidebar>
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  toggleSidebar: PropTypes.func,
  collapseSidebar: PropTypes.func,
  collapsed: PropTypes.bool,
  toggled: PropTypes.bool,
  authentication_state: PropTypes.object
};

const mapStateToProps = ({ sidebar, authentication }) => ({
  collapsed: sidebar.collapsed,
  toggled: sidebar.toggled,
  authentication_state: authentication
});

export default connect(mapStateToProps, {
  toggleSidebar: updateSidebarToggle
})(Sidebar);